import axios from 'axios'
import { endpoints } from './endpoints';
import {APP_NAME} from '../utils'

const apiAccessRequestEndpoints = endpoints.apiAccessRequest;

export function getAll() {
  return axios.get(apiAccessRequestEndpoints.getAll())
}

export function add(data: any){
  return axios.post(apiAccessRequestEndpoints.getAll(), data)
}

export function sendVerificationCode(email: string, languageCode: string){
  return axios.post(apiAccessRequestEndpoints.sendVerificationCode(), {email, language_code:languageCode, origin: APP_NAME})
}

export function updateStatus(apiAccessRequestId: number, status: string, reviewComment?: string){
  return axios.patch(apiAccessRequestEndpoints.updateStatus(apiAccessRequestId, status), {review_comment:reviewComment})
}